import { useEffect } from 'react'
import { createPortal } from 'react-dom'

export default function DealWonToast({ onEnd }) {
  useEffect(() => {
    const timer = setTimeout(onEnd, 2000)
    return () => clearTimeout(timer)
  }, [onEnd])
  return createPortal(<div className="dp-won-toast" role="status" aria-live="polite">Negócio ganho! <span aria-hidden="true">🎉</span></div>, document.body)
}
